import * as React from 'react'
export const SvgChevronRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} {...props}>
    <path d="M9 16.137L13.22 12 9 7.863 10.39 6.5 16 12l-5.61 5.5z" />
  </svg>
)
export default SvgChevronRight
